module.exports = __webpack_public_path__ + "img/LogoDashboard-12.549f7911.svg";